// extracted by mini-css-extract-plugin
export default {"banner":"MLi5Ipd","content":"gEfDl75","image":"v6eQikK","textContainer":"gtoKPEK","headline":"A7LN47H","text":"v8PSEwC"};